export const fonts = {
	fontFamily: 'Avenir',
	fontFamilyTitle: 'Avenir',
}
